/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import cx from 'classnames';
import { usePrefix } from '../../internal/usePrefix.js';

function FormItem(_ref) {
  let {
    className,
    children,
    ...rest
  } = _ref;
  const prefix = usePrefix();
  const classNames = cx(`${prefix}--form-item`, className);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: classNames
  }, rest), children);
}
FormItem.propTypes = {
  /**
   * Provide content to be rendered in the form item
   */
  children: PropTypes.node,
  /**
   * Provide a custom className to be applied to the containing node
   */
  className: PropTypes.string
};

export { FormItem as default };
